<template>
  <b-row>
    <b-col cols="12">
      <div class="mt-2">
        <b-input
          placeholder="Pesquise pelo código do pedido"
          debounce="1000"
          class="mb-1"
          v-model="searchFields.orderCode"
          :disabled="loadingOrders"
          @keydown.enter="listOrders"
        />
      </div>
    </b-col>
    <b-col cols="12" class="mt-3 mb-5 h-100">
      <b-table
        hover
        striped
        bordered
        show-empty
        empty-text="Não há produtos integrados a ClearSale"
        :busy="loadingOrders"
        :fields="table.headers"
        :items="table.items"
      >
        <template #cell(actions)="{ item }">
          <div
            class="d-flex align-items-center justify-content-center"
            style="gap: 0.8rem"
          >
            <b-button
              size="sm"
              variant="info"
              title="Visualizar histórico de integração"
              @click="$refs.seeOrderHistoryModal.open(item.orderDetails.id)"
            >
              <i class="fas fa-eye"></i>
            </b-button>
          </div>
        </template>
      </b-table>
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loadingOrders"
        align="center"
        pills
      ></b-pagination>
    </b-col>

    <SeeOrderHistoryModal ref="seeOrderHistoryModal" />
  </b-row>
</template>

<script>
import { mapState } from 'vuex';

import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';
import IntegrationTypes from 'Enums/Integration/IntegrationTypes';
import { getText as getStatusLabel } from 'Enums/Order/Status'
import { buildRequiredIntegrationQueryParams } from '@/utils/integration';
import { formatMoney } from '@/utils/number';
import SeeOrderHistoryModal from './SeeOrderHistoryModal.vue';

export default {
  name: 'ListOrders',
  mixins: [makeToast],
  props: {},
  computed: {
    ...mapState(['dadosUsuario']),
  },
  data() {
    return {
      loadingOrders: false,
      searchFields: {
        orderCode: '',
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'orderDetails.id',
            label: 'Código do pedido',
          },
          {
            key: 'orderDetails.status',
            label: 'Status do pedido',
            formatter(value) {
              return getStatusLabel(value);
            }
          },
          {
            key: 'orderDetails.total',
            label: 'Total',
            tdClass: 'text-right',
            thClass: 'text-right',
            formatter(value) {
              return formatMoney(value);
            },
          },
          {
            key: 'user',
            label: 'Usuário',
            formatter(value, key, item) {
              return `${value.name} (${value.email})`;
            },
          },
          {
            key: 'createdAt',
            label: 'Integrado em',
            formatter(value, key, item) {
              return new Date(value).toLocaleString('pt-BR');
            },
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
            thStyle: {
              width: '80px',
            },
          },
        ],
        items: [],
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        total: 0,
        lastPage: 0,
      },
    };
  },
  watch: {
    'searchFields.orderCode': function () {
      this.pagination = {
        currentPage: 1,
        itemsPerPage: 10,
        total: 0,
        lastPage: 0,
      };
      this.listOrders();
    },
    'pagination.currentPage': function () {
      this.listOrders();
    },
  },
  mounted() {
    this.listOrders();
  },
  methods: {
    async listOrders() {
      if (this.loadingOrders) return;

      this.loadingOrders = true;

      const requiredParams = buildRequiredIntegrationQueryParams(
        this.dadosUsuario.id,
        IntegrationTypes.CLEAR_SALE
      );

      const params = new URLSearchParams(requiredParams);
      params.append('page', this.pagination.currentPage);
      params.append('perPage', this.pagination.itemsPerPage);
      params.append('orderCode', this.searchFields.orderCode || '');

      try {
        const { data } = await shopkeeperAppApi.get(
          `/integration/anti-fraud/clearsale/orders?${params.toString()}`
        );

        const { items, total } = data.data;

        this.$set(this.table, 'items', items || []);

        this.pagination.total = total;
      } catch {
        this.makeToast(
          'Erro',
          `Houve um ao buscar os pedidos integrados na ClearSale`,
          'danger'
        );
      } finally {
        this.loadingOrders = false;
      }
    },
  },
  components: {
    SeeOrderHistoryModal,
  },
};
</script>
